import type { ComponentChildren } from 'preact'
import { styled } from '../setup'
import { colors } from '../theme'

const Container = styled('div')`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${colors.bgPage};
`

interface AuthLayoutProps {
  children: ComponentChildren
}

export function AuthLayout({ children }: AuthLayoutProps) {
  return <Container>{children}</Container>
}
